var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0837 1.75V0.583333C11.0837 0.428624 11.0222 0.280251 10.9128 0.170854C10.8034 0.0614582 10.655 0 10.5003 0C10.3456 0 10.1972 0.0614582 10.0878 0.170854C9.97845 0.280251 9.91699 0.428624 9.91699 0.583333V1.75H11.0837Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.08366 1.75V0.583333C4.08366 0.428624 4.0222 0.280251 3.9128 0.170854C3.80341 0.0614582 3.65504 0 3.50033 0C3.34562 0 3.19724 0.0614582 3.08785 0.170854C2.97845 0.280251 2.91699 0.428624 2.91699 0.583333V1.75H4.08366Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 13.4168H1.75C1.28587 13.4168 0.840752 13.2325 0.512563 12.9043C0.184374 12.5761 0 12.131 0 11.6668L0 4.0835C0 3.61937 0.184374 3.17425 0.512563 2.84606C0.840752 2.51787 1.28587 2.3335 1.75 2.3335H12.25C12.7141 2.3335 13.1592 2.51787 13.4874 2.84606C13.8156 3.17425 14 3.61937 14 4.0835V11.6668C14 12.131 13.8156 12.5761 13.4874 12.9043C13.1592 13.2325 12.7141 13.4168 12.25 13.4168ZM12.8333 5.25016H1.16667V11.6668C1.16667 11.8215 1.22812 11.9699 1.33752 12.0793C1.44692 12.1887 1.59529 12.2502 1.75 12.2502H12.25C12.4047 12.2502 12.5531 12.1887 12.6625 12.0793C12.7719 11.9699 12.8333 11.8215 12.8333 11.6668V5.25016Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66634 6.4165H2.33301V8.1665H4.66634V6.4165Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16634 6.4165H5.83301V8.1665H8.16634V6.4165Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66634 9.3335H2.33301V11.0835H4.66634V9.3335Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16634 9.3335H5.83301V11.0835H8.16634V9.3335Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6663 6.4165H9.33301V8.1665H11.6663V6.4165Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCalendarIcon);
export default __webpack_public_path__ + "static/media/newCalendarIcon.56e1db4e.svg";
export { ForwardRef as ReactComponent };